import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=4edebff2&scoped=true&"
import script from "./OrderSummary.vue?vue&type=script&lang=js&"
export * from "./OrderSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edebff2",
  null
  
)

export default component.exports